// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1066":"65a985bf","3440":"65a985bf","3583":"65a985bf","7913":"65a985bf","8931":"65a985bf"}[chunkId] + ".chunk.css";
};